<script>
export default {
  props: {
    news: {
      type: Object,
    },
  },
};
</script>

<template>
  <div>
    <router-link :to="{name: 'OrganizationView', params: {id: news.textParams[0]}}">
      {{ news.textParams[1] }}
    </router-link>
    {{$t('news.template.opinion.updatedByOrg.p1')}}
    {{ news.textParams[2] }}
    {{ news.textParams[3] }}
    {{ news.textParams[4] }}
    {{ news.textParams[5] }}
    {{ news.textParams[6] }}
    {{ news.textParams[7] }}
    {{ news.textParams[8] }}
    {{$t('news.template.opinion.updatedByOrg.p2')}}
    "<router-link
      :to="{name: 'OpinionView', params: {hash: news.textParams[9]}}">
      {{ news.textParams[10] }}
    </router-link>"
    {{$t('news.template.opinion.updatedByOrg.p3')}}
    "<router-link
      :to="{name: 'OpinionView', params: {hash: news.textParams[9]}}">
      {{ news.textParams[11] }}
    </router-link>"
  </div>
</template>
